'use strict';

export class ReportAd {
	constructor($root) {
		
		this.$root = $root;
		
		/**
		 * Internal state
		 */
		this.valid_msg_id = false;
		this.msg_id       = "";
		this.file         = null;
		this.email        = "";
		this.phone        = "";
		this.message       = "";
		this.username       = "";

		/**
		 * Cache jQuery elements
		 */
		this.$phone_abuse_input   = this.$root.find(".js-faqra_phone_abuse_input");
		this.$input_ad_id         = this.$root.find(".js-faqra_input_ad_id");
		this.$wrong_id_no_button  = this.$root.find(".js-faqra_wrong_id_no_button");
		this.$input_email         = this.$root.find(".js-faqra_input_email");
		this.$input_username         = this.$root.find(".js-faqra_input_username");
		this.$form_ad_id          = this.$root.find(".js-faqra_form_ad_id");
		this.$form_username          = this.$root.find(".js-faqra_form_username");
		this.$all_submit_buttons  = this.$root.find(".js-faqra_submit_button");
		this.$information_check   = this.$root.find(".js-faqra_information_check");
		this.$upload_proof        = this.$root.find(".js-faqra_upload_proof");
		this.$input_proof_file    = this.$root.find(".js-faqra_input_proof_file");
		this.$yes_no_buttons      = this.$root.find(".js-faqra_yes_no_buttons");
		this.$back_to_locanto     = this.$root.find(".js-faqra_back_to_locanto");
		this.$feedback_wrapper    = this.$root.find(".js-faq_meta_results__question.active")
									 .find(".js-faq_meta_results__feedback_wrapper");

		this._original_form_html = this.$root.html();

		// Hide initially feedback wrapper
		yalwa.basics.hide(this.$feedback_wrapper);

		/**
		 * Map form 'data-type' to handler methods
		 */
		this.actions = {
			"ad_id": this.handle_ad_id_submission.bind(this),
			"username": this.handle_username_submission.bind(this),
			"email": this.handle_email_submission.bind(this),
			"message": this.handle_message_submission.bind(this)
		};
		/**
		 * Initialize all event listeners
		 */
		this.init_event_listeners();
	}

	/**
	 * Organize all event bindings here.
	 */
	init_event_listeners() {

		// File upload button & file selection (scoped to visible form only)
		const $visible_form = this.$root;
		
		// Clicking "Yes" -> user knows Ad ID
		this.$root.find(".js-faqra_know_ad_id").on("click", this.show_ad_id_form.bind(this));
		// Clicking "Username" -> user knows username
		this.$root.find(".js-faqra_know_username").on("click", this.show_username_form.bind(this));

		// "No" -> user does NOT want to correct the ID
		this.$root.find(".js-faqra_wrong_id_no").on("click", this.handle_wrong_id_no.bind(this));
		// "Yes" -> user DOES want to correct the ID
		this.$root.find(".js-faqra_wrong_id_yes").on("click", () => this.reset_form());

		// Input validation on every keystroke
		this.$phone_abuse_input.on("input", this.validate_input.bind(this));
		// Show sublebel on focus
		this.$phone_abuse_input.on("focus", function() {
			yalwa.basics.show(jQuery(this).parent().next());
		});
		// Press 'Enter' triggers the correct form action
		this.$phone_abuse_input.on("enterdown", this.handle_submit_input.bind(this));

		// Any "Submit" button
		this.$all_submit_buttons.on("click", this.handle_submit_input.bind(this));

		// File upload button & file selection
		$visible_form.find(".js-faqra_upload_proof")
			.on("click", () => {
				$visible_form.find(".js-faqra_input_proof_file").click();
			});

		$visible_form.find(".js-faqra_input_proof_file")
			.on("change", this.handle_file_change.bind(this));
	}

	/**
	 * Show form to enter Ad ID
	 */
	show_ad_id_form() {
		yalwa.basics.show(this.$form_ad_id);
		yalwa.basics.show(this.$root.find(".js-faqra_faq_phone_yes"));
		yalwa.basics.hide(this.$yes_no_buttons);
	}

reset_form() {
		console.log('[ReportAd] reset_form');
		this.$root.html(this._original_form_html);

		this.$phone_abuse_input   = this.$root.find(".js-faqra_phone_abuse_input");
		this.$input_ad_id         = this.$root.find(".js-faqra_input_ad_id");
		this.$wrong_id_no_button  = this.$root.find(".js-faqra_wrong_id_no_button");
		this.$input_email         = this.$root.find(".js-faqra_input_email");
		this.$input_username      = this.$root.find(".js-faqra_input_username");
		this.$form_ad_id          = this.$root.find(".js-faqra_form_ad_id");
		this.$form_username       = this.$root.find(".js-faqra_form_username");
		this.$all_submit_buttons  = this.$root.find(".js-faqra_submit_button");
		this.$information_check   = this.$root.find(".js-faqra_information_check");
		this.$upload_proof        = this.$root.find(".js-faqra_upload_proof");
		this.$input_proof_file    = this.$root.find(".js-faqra_input_proof_file");
		this.$yes_no_buttons      = this.$root.find(".js-faqra_yes_no_buttons");
		this.$back_to_locanto     = this.$root.find(".js-faqra_back_to_locanto");

		this.valid_msg_id = false;
		this.msg_id = "";
		this.phone = "";
		this.email = "";

		this.init_event_listeners();
	}

	/**
	 * Show form to enter Username
	 */
	show_username_form() {        
		yalwa.basics.show(this.$form_username);
		yalwa.basics.show(this.$root.find(".js-faqra_faq_phone_no"));
		yalwa.basics.hide(this.$yes_no_buttons);
	}

	/**
	 * User chooses "No" to correct ID -> show "try again" message
	 */
	handle_wrong_id_no(e) {
		yalwa.basics.hide(this.$wrong_id_no_button);
		yalwa.basics.show(this.$root.find(".js-faqra_faq_phone_try_again_no"));
		yalwa.basics.show(this.$back_to_locanto);
		yalwa.basics.show(this.$feedback_wrapper);
	}

	/**
	 * Validate input whenever user types in an ad ID or email.
	 */
	validate_input(e) {
		const $input             = jQuery(e.currentTarget);
		const input_value        = $input.val().trim();
		const input_type         = $input.attr("type");
		const $parent_div        = $input.parent().parent();
		const $input_submit_btn  = $input.next();

		let is_valid = false;

		if (input_type === "text") {
			// Only text allowed
			is_valid = true;
		} else if (input_type === "number") {
			// Only number allowed
			is_valid = true;
		} else if (input_type === "email") {
			// Basic email format check
			is_valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input_value);
		}

		this.valid_msg_id = is_valid;
		$parent_div.toggleClass("phone_abuse_error", !is_valid);
		yalwa.basics.toggle($input_submit_btn, is_valid);
	}

	/**
	 * Clicking on a "Submit" button (Or Enter inside input) determines which action to call (ad-id, email).
	 */
	handle_submit_input(e) {
		this.actions[jQuery(e.currentTarget).parent().data("type")]?.(e);
	}

	/**
	 * Handle submission when the user enters Ad ID.
	 */
	handle_ad_id_submission(e) {

		//Without this line, the form will hidden by parent listener
		e.stopPropagation();

		if (!this.valid_msg_id) {
			return;
		}

		this.msg_id = this.$input_ad_id.val().trim();
		
		const $parent_div = jQuery(e.currentTarget).parent();

		// Display the submitted Ad ID
		$parent_div.html(`
			<div class="faq_phone_abuse_form__question_section_answer">
				${this.msg_id}
			</div>
		`);

		yalwa.basics.hide($parent_div.next());
		yalwa.basics.show(this.$information_check);

		jQuery.ajax({
			type: 'POST',
			url: '/api/ajax/general/',
			dataType: 'json',
			data: {
				action: 'report_ad_faq',
				msgID: this.msg_id,
				sub_action: 'validate_ad_id',
				csrf_bust: yalwa.v.csrf_bust
			}
		}).done((response) => {
			setTimeout(() => {
				if (response.success) {
					yalwa.basics.show(this.$root.find(".js-faqra_issue_message"));
				} else {
					yalwa.basics.show(this.$root.find(".js-faqra_wrong_ad_id"));
					if (response.phone_not_found) {
						yalwa.basics.show(this.$root.find(".js-faqra_phone_number_not_found"));
					} else {
						yalwa.basics.show(this.$root.find(".js-faqra_posting_not_found"));
					}
				}
			}, 2000);
		});
	}

	handle_username_submission(e) {

		//Without this line, the form will hidden by parent listener
		e.stopPropagation();

		this.username = this.$input_username.val().trim();
		
		const $parent_div = jQuery(e.currentTarget).parent();

		// Display the submitted Username
		$parent_div.html(`
			<div class="faq_phone_abuse_form__question_section_answer">
				${this.username}
			</div>
		`);

		jQuery.ajax({
			type: 'POST',
			url: '/api/ajax/general/',
			dataType: 'json',
			data: {
				action: 'report_ad_faq',
				username: this.$input_username.val().trim(),
				sub_action: 'validate_username',
				csrf_bust: yalwa.v.csrf_bust
			}
		}).done((response) => {
			setTimeout(() => {
				if (response.success) {
					yalwa.basics.show(this.$root.find(".js-faqra_issue_message"));
				} else {
					yalwa.basics.show(this.$root.find(".js-faqra_wrong_ad_id"));
					if (response.phone_not_found) {
						yalwa.basics.show(this.$root.find(".js-faqra_phone_number_not_found"));
					} else {
						yalwa.basics.show(this.$root.find(".js-faqra_posting_not_found"));
					}
				}
			}, 2000);
		});
		
	}

	/**
	 * Handle submission when the user enters an email address.
	 */
	handle_email_submission(e) {

		this.email = this.$input_email.val().trim();

		// Validate email format like test@test.com
		const is_valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
		if (!is_valid) return;

		// Prevent if already disabled
		if (this.$input_email.prop("disabled")) return;
		this.$input_email.prop("disabled", true);

		const $parent_div = jQuery(e.currentTarget).parent();
		const form_data = new FormData();

		// Append multiple files
		const files = this.$input_proof_file[0]?.files;
		if (files?.length > 0) {
			Array.from(files).forEach((file, index) => {
				form_data.append(`files[]`, file);
			});
		}

		// Append message
		form_data.append("message", this.message);
		form_data.append("email", this.email);
		form_data.append("action", "report_ad_faq");
		form_data.append("sub_action", "send_message");
		form_data.append("csrf_bust", yalwa.v.csrf_bust);

		if (this.msg_id) {
			form_data.append("msgID", this.msg_id);
		}
		if (this.username) {
			form_data.append("username", this.username);
		}

		jQuery.ajax({
			type: "POST",
			url: "/api/ajax/general/",
			data: form_data,
			processData: false,
			contentType: false,
			dataType: "json",
		}).done((response) => {
			const $upload_status = this.$root.find(".js-faqra_upload_status");
			if (response.success) {
				$parent_div.html(`
					<div class="faq_phone_abuse_form__question_section_answer">
						${this.email}
					</div>
				`);
				yalwa.basics.show(this.$root.find(".js-faqra_thank_you_for_email"));
				yalwa.basics.show(this.$back_to_locanto);
				yalwa.basics.show(this.$feedback_wrapper);
			} else {
				$upload_status
					.text("Upload failed. Please try again.")
					.css("color", "red");
			}
		});
	}

	handle_message_submission(e) {
		const $message_container = this.$root.find(".js-faqra_input_message");

		this.message = $message_container.val().trim();

		$message_container.next().hide();

		$message_container
		.replaceWith('<div class="faq_phone_abuse_form__question_section_textarea faq_phone_abuse_form__question_section_textarea--text-submitted">' + this.message +'</div>');


		yalwa.basics.show(this.$root.find(".js-faqra_proof_upload_section"));
	}

	/**
	 * Handle file selection for proof upload
	 */
	handle_file_change() {
		const files = this.$input_proof_file[0]?.files;

		if (!files || files.length === 0) return;

		const max_total_size = 11 * 1024 * 1024;
		let total_size = 0;

		if (files?.length > 0) {
			for (const file of files) {
				total_size += file.size;
			}
			if (total_size > max_total_size) {
				yalwa.basics.label('file_upload_error', 'main').done(label => {
				    yalwa.basics.toast({message: label, type: 'error'});
				});
				return;
			}
		}

		const $upload_section = this.$root.find(".js-faqra_proof_upload_replace");

		$upload_section.empty();

		Array.from(files).forEach((file) => {
			let img =yalwa.basics.yimage('attach-file', {
				pixel: 24,
				folder: 'main',
				classes: '',
				site: 'mobile'
			});            
			const fileBlock = jQuery(`
				<div class="faq_phone_abuse_form__question_section_upload_button">
					<div class="upload-button upload-button--uploaded uploaded-file">
						${img}
						<span>${file.name}</span>
					</div>
				</div>
			`);

			$upload_section.append(fileBlock);
		});

		yalwa.basics.show(this.$root.find(".js-faqra_information_verified"));

	}
}